import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ICategoriaDeProduto } from '../types/ICategoriaDeProduto';
import { IGetPostBase64Params } from '../types/IGetPostBase64Params';
import { IBannerHome } from '../types/IBannerHome';
import { EAmbiente } from '../types/EAmbienteGetBannerHome';
import bannerHomeMock from '../mocks/bannerHome';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProdutoService {

  private host = environment.api.host;
  private methods = environment.api.endpoints.methods.produto;
  private corretorMethods = environment.api.endpoints.methods.corretor;

  constructor(
    private http: HttpClient,
  ) { }

  getProdutos() {
    const url = this.host + this.corretorMethods.get.produtos;

    return this.http.get<ICategoriaDeProduto[]>(url);
  }

  getPostBase64(queryParams: IGetPostBase64Params) {
    const url = this.host + this.corretorMethods.get.downloadDeMaterialDeVenda;

    return this.http.get(url, { params: queryParams as any });
  }

  getBannerHome(ambiente: EAmbiente, uf: string) {
    const url = this.host + this.methods.get.banner;

    return this.http.get<IBannerHome>(url, { params: { ambiente, uf } as any });
  }
}